export default{
     // ABOUT SUPPLIER
  for: "لـ",
  with: "مع",
  grow_business: "نمِّ أعمال التوريد الخاصة بك",
  supplier_desc:
    "MAHAL هو سوق B2B مصمم لمساعدة الموردين على التواصل مباشرة مع المطاعم، والحصول على طلبات مستمرة، وتنمية أعمالهم بثقة.",
  supplier_text:
    "من المنتجين المحليين إلى الموزعين الكبار، تمكّن MAHAL الموردين من الوصول إلى مطاعم موثوقة، وتسعير شفاف، وشراكات تجارية طويلة الأمد — كل ذلك في منصة واحدة.",

  highlight1: "وصول مباشر إلى المطاعم",
  highlight2: "طلبات بالجملة ومتكررة",
  highlight3: "مدفوعات آمنة وفي الوقت المناسب",
  highlight4: "دعم نمو الأعمال",

  become_supplier: "كن موردًا",
  talk_team: "تحدث مع فريقنا",
}